import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { saveAs } from 'file-saver';
import { PermissionsService } from '../services/permissions.service';
import { SortListService } from '../services/sort-list.service';

@Component({
  selector: 'app-visitor-payment-verification',
  templateUrl: './visitor-payment-verification.component.html',
  styleUrls: ['./visitor-payment-verification.component.scss']
})
export class VisitorPaymentVerificationComponent implements OnInit {
 public payment_verification: any;
  public visit_date = moment(new Date()).format('YYYY-MM-DD');
  public perPage = 20;
  public totalCount = 0;
  public page = 1;
  public mobile_no: string = '';

  constructor(
    private apiService: ApiService,
    private appComponent: AppComponent,
    public permissionsService: PermissionsService,
    private sortListService: SortListService
    ) { }

  ngOnInit() {
  }


  getList(_type) {
    this.appComponent.showLoader();
    const visit_date = moment(this.visit_date).format('YYYY-MM-DD');
    const mobile_no = this.mobile_no ? this.mobile_no : '';
    this.apiService.getDataFromServer(`/admin/get_visitors_by_mobile?date_of_visit=${visit_date}&mobile_no=${mobile_no}`).subscribe(
      (res: any) => {
        this.payment_verification = res.data;
        this.appComponent.hideLoader();
        this.payment_verification.map(res => {
          res.date_of_visit = moment.utc(res.date_of_visit).local().format('DD-MM-YYYY');
          res.created_at = moment.utc(res.created_at).local().format('DD-MM-YYYY');
        });
        this.appComponent.showMessageAlert(res['message'], 'success');
      },
      err => {
        this.appComponent.hideLoader();
        console.log(err);
        this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
        
      }
    );
  }

  verifyPayment(_id){
    
      this.appComponent.showLoader();
      this.apiService.getDataFromServer(`/admin/restore_and_verify_payment?visitor_id=${_id}`).subscribe(
      (res: any) => {
        const verify = res;
        console.log('responce - ' + verify);
        this.appComponent.hideLoader();
        this.getList('');
      },
      err => {
        this.appComponent.hideLoader();
        
        this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
        console.log(err);
      }
    );
  }

  
  

}


